import { AthleteKiloClassAthleteAgenda, AthleteKiloClassAthleteRetrieve } from 'types';

export type AthleteClassState =
  | 'noRelation'
  | 'waitlisted'
  | 'reserved'
  | 'reservedUncredited'
  | 'reservedAndCheckedIn'
  | 'notReservedButCheckedIn'
  | 'lateCancelWithCreditDeduction'
  | 'lateCancelWithoutCreditDeduction'
  | 'noShowWithCreditDeduction'
  | 'noShowWithoutCreditDeduction';

export default function useAthleteClassState(
  athleteKiloClass: AthleteKiloClassAthleteAgenda | AthleteKiloClassAthleteRetrieve | undefined,
): AthleteClassState {
  if (!athleteKiloClass) {
    return 'noRelation';
  }

  const { isReserved, isCheckedIn, isWaitlisted, isLateCancel, isNoShow, isCredited } = athleteKiloClass;

  if (isNoShow) {
    return isCredited ? 'noShowWithCreditDeduction' : 'noShowWithoutCreditDeduction';
  }

  if (isLateCancel) {
    return isCredited ? 'lateCancelWithCreditDeduction' : 'lateCancelWithoutCreditDeduction';
  }

  if (isCheckedIn) {
    return isReserved ? 'reservedAndCheckedIn' : 'notReservedButCheckedIn';
  }

  if (isWaitlisted) {
    return 'waitlisted';
  }

  if (isReserved) {
    return isCredited ? 'reserved' : 'reservedUncredited';
  }

  return 'noRelation';
}
